export default __webpack_public_path__ + "static/media/introcashplan.035744a4.svg";